import { Button, Checkbox, Form, PopoverProps, Typography } from 'antd';

import { Role } from '@app/domain-interfaces';

export const useRoleSettingsPopover = () => {
  const [form] = Form.useForm();
  const enabled = Form.useWatch('enabled', form);

  const testRoles = JSON.parse(window.sessionStorage.getItem('saaf_test_roles') ?? '[]');
  const initialValues = {
    enabled: window.sessionStorage.getItem('saaf_test_roles_enabled') === 'true',
    bundleAdmin: testRoles.includes(Role.BUNDLE_ADMIN),
    ruleAdmin: testRoles.includes(Role.RULE_ADMIN),
    t3Admin: testRoles.includes(Role.NODE_ACCESS_ADMIN),
  };

  const getPopoverProps = (): PopoverProps => {
    const displayRoles = testRoles.map((role: Role): string => {
      switch (role) {
        case Role.BUNDLE_ADMIN:
          return 'BUNDLE';
        case Role.RULE_ADMIN:
          return 'RULE';
        case Role.NODE_ACCESS_ADMIN:
          return 'T3';
        default:
          return '';
      }
    });
    return {
      children: initialValues.enabled
        ? displayRoles.length !== 0
          ? `${displayRoles.join(', ')} ADMIN`
          : 'GENERAL USER'
        : 'SYSTEM ADMIN',
      content: (
        <Form
          form={form}
          initialValues={initialValues}
          onFinish={(data) => {
            window.sessionStorage.setItem('saaf_test_roles_enabled', data.enabled.toString());

            const newRoles: Role[] = [];
            if (data.bundleAdmin) {
              newRoles.push(Role.BUNDLE_ADMIN);
            }
            if (data.ruleAdmin) {
              newRoles.push(Role.RULE_ADMIN);
            }
            if (data.t3Admin) {
              newRoles.push(Role.NODE_ACCESS_ADMIN);
            }
            window.sessionStorage.setItem('saaf_test_roles', JSON.stringify(newRoles));
            window.location.reload();
          }}
          size="small"
          layout="vertical"
        >
          <Form.Item name="enabled" valuePropName="checked">
            <Checkbox>Use Test Roles</Checkbox>
          </Form.Item>
          <Typography.Title level={5} style={{ marginTop: 0, marginBottom: 0 }}>
            Test Roles
          </Typography.Title>
          <Form.Item name="bundleAdmin" valuePropName="checked">
            <Checkbox disabled={!enabled}>Bundle Admin</Checkbox>
          </Form.Item>
          <Form.Item name="ruleAdmin" valuePropName="checked">
            <Checkbox disabled={!enabled}>Rule Admin</Checkbox>
          </Form.Item>
          <Form.Item name="t3Admin" valuePropName="checked">
            <Checkbox disabled={!enabled}>T3 Admin</Checkbox>
          </Form.Item>
          <Button htmlType="submit" type="primary">
            Apply
          </Button>
        </Form>
      ),
    };
  };

  return { getPopoverProps };
};
